import React from "react";
import Nav from "react-bootstrap/Nav";
import { useHistory } from "react-router";
import { NavDropdown } from "react-bootstrap";

export default function OperatorMenu() {
  const history = useHistory();

  return (
    <>
      <Nav.Item>
        <Nav.Link
          eventKey="/home"
          onClick={(e) => {
            history.push("MGConote");
          }}
        >
          จัดการคอนโน๊ต
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="/home"
          onClick={(e) => {
            history.push("ScanConote");
          }}
        >
          แสกนคอนโน๊ต
        </Nav.Link>
      </Nav.Item>
    </>
  );
}
